"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import { ScrollArea } from "@base-ui/react/scroll-area";
import { cn } from "../../utils/index.js";
import { DRAWER_SWIPE_IGNORE_ATTRIBUTE } from "../../utils/constants.js";
import { scrollAreaHorizontalScrollbar, scrollAreaHorizontalThumb, scrollAreaVariants } from "./ScrollArea.variants.js";
function ScrollArea_ScrollArea({ children, className, headerNode, orientation = 'vertical', slots = {
    root: '',
    viewport: '',
    content: '',
    scrollbar: '',
    thumb: ''
}, ...props }) {
    const { root, viewport, content, scrollbar, thumb } = scrollAreaVariants({
        ...props,
        orientation
    });
    const rootClasses = cn(root(), className ?? slots.root);
    const viewportClasses = cn(viewport(), slots.viewport);
    const contentClasses = cn(content(), slots.content);
    const scrollbarClasses = cn(scrollbar(), slots.scrollbar);
    const thumbClasses = cn(thumb(), slots.thumb);
    const showVerticalScrollbar = 'vertical' === orientation || 'both' === orientation;
    const showHorizontalScrollbar = 'horizontal' === orientation || 'both' === orientation;
    const drawerBodySwipeProps = true === props.drawerBody ? {
        [DRAWER_SWIPE_IGNORE_ATTRIBUTE]: ''
    } : {};
    return /*#__PURE__*/ jsxs(ScrollArea.Root, {
        className: rootClasses,
        ...drawerBodySwipeProps,
        children: [
            /*#__PURE__*/ jsxs(ScrollArea.Viewport, {
                tabIndex: 0,
                className: viewportClasses,
                children: [
                    headerNode,
                    /*#__PURE__*/ jsx("div", {
                        className: contentClasses,
                        children: children
                    })
                ]
            }),
            showVerticalScrollbar && /*#__PURE__*/ jsx(ScrollArea.Scrollbar, {
                orientation: "vertical",
                className: scrollbarClasses,
                children: /*#__PURE__*/ jsx(ScrollArea.Thumb, {
                    className: thumbClasses
                })
            }),
            showHorizontalScrollbar && /*#__PURE__*/ jsx(ScrollArea.Scrollbar, {
                orientation: "horizontal",
                className: cn(scrollbar(), scrollAreaHorizontalScrollbar, slots.scrollbar),
                children: /*#__PURE__*/ jsx(ScrollArea.Thumb, {
                    className: cn(thumb(), scrollAreaHorizontalThumb, slots.thumb)
                })
            }),
            'both' === orientation && /*#__PURE__*/ jsx(ScrollArea.Corner, {})
        ]
    });
}
export { ScrollArea_ScrollArea as ScrollArea };
